import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';
import type { QueryDto } from '@shared/types';

const KEY = ['admin', 'queries'] as const;

export interface QueryInput {
  label: string;
  queryString: string;
  isEnabled: boolean;
}

export function useAdminQueries() {
  const qc = useQueryClient();

  const list = useQuery({
    queryKey: KEY,
    queryFn: async () => (await api.get<{ data: QueryDto[] }>('/admin/queries')).data,
  });

  const create = useMutation({
    mutationFn: (input: QueryInput) =>
      api.post<{ data: { id: string } }>('/admin/queries', input),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });

  const update = useMutation({
    mutationFn: ({ id, ...input }: QueryInput & { id: string }) =>
      api.patch<{ data: { id: string } }>(`/admin/queries/${id}`, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });

  const remove = useMutation({
    mutationFn: (id: string) => api.delete<{ data: { id: string } }>(`/admin/queries/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });

  return { list, create, update, remove };
}
